import { useForm } from "react-hook-form";
import { Button, InputField } from "../../../components/forms";
import Datepicker from "../../../components/generic/Datepicker";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { addressRegex, emailReg, numReg, textReg } from "../../../utils/regex";
import { countries } from "../../../constant/data";
import { useSelector } from "react-redux";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { GoPlus } from "react-icons/go";
import { FaSave } from "react-icons/fa";
import { useEffect, useState } from "react";
import {
  onAddEmployeeemgContact,
  onAddEmployeeKin,
  onGetemployeeEmgContact,
  onGetemployeeKin,
  onUpdateContactDetails,
  onUpdateEmployeeDetails,
  onUpdateKinDetails,
} from "../../../services/employee";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";

export default ({ details }: any) => {
  const dateofbirthPick = usePickerhook();
  var { control, handleSubmit, watch, setValue } = useForm();
  const departmentPickhook = usePickerhook();
  const nationalityPickhook = usePickerhook();
  const genderPickhook = usePickerhook();
  const maritalPickhook = usePickerhook();
  const countrypicked = usePickerhook();
  const { SelectedOrg, selectedEmployee } = useStateGetter();
  const watchedFields = watch([
    "firstname",
    "lastname",
    "email",
    "address",
    "emgname",
    "phone",
    "emgphone",
    "kinaddress",
    "kinemail",
    "kinfirstname",
    "kinlastname",
    "kinphone",
    "kinrelationship",
  ]);
  const [kindetails, setkindetails] = useState<any>({});
  const [emgdetails, setemgdetails] = useState<any>({});
  const { config, isloading } = useStateGetter();

  const { setLoading, setselectedEmpl } = useStateSetter();

  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      // maritalPickhook.pickedRole &&
      genderPickhook.pickedRole &&
      nationalityPickhook.pickedRole
  );




  const onSubmit = async (data: any) => {
    console.log(data);
    setLoading(true);

    if (!genderPickhook.pickedRole) {
      toast.error("Gender cannot be empty");
      return;
    }
    try {
      var personaldetailsPostdata = {
        firstName: data.firstname,
        lastName: data.lastName,
        dateOfBirth: dateofbirthPick.pickedRole.code
          .toISOString()
          .split("T")[0],
        gender: genderPickhook.pickedRole.name,
        address: data.address + data.address_additional,
        city: data.city,
        country: countrypicked.pickedRole.name,
        workLocation: SelectedOrg.address,
        workPhone: data.phone,
      };

      //update profile info
      var persdetres = await onUpdateEmployeeDetails(
        selectedEmployee.id,
        personaldetailsPostdata,
        config
      );
      if (persdetres.success) {
        toast.success(persdetres.message);
        setselectedEmpl(persdetres.data);
      }

      if (!kindetails.employeeID) {
        // kin details has not been added before and is an add instead of update
        let kinPostData = {
          employeeID: selectedEmployee.id,
          nextOfKinFirstName: data.kinfirstname,
          nextOfKinLastName: data.kinlastname,
          nextOfKinEmail: data.kinemail,
          nextOfKinPhoneNumber: data.kinphone,
          nextOfKinRelationship: data.kinrelationship,
          nextOfKinAddress: data.kinaddress,
        };

        var addkingres = await onAddEmployeeKin(kinPostData, config);

        if (addkingres.success) {
          toast.success(addkingres.message);
          setkindetails(addkingres.data);
        }
      } else {
        // update kindetails
        let kinPostData = {
          nextOfKinFirstName: data.kinfirstname,
          nextOfKinLastName: data.kinlastname,
          nextOfKinEmail: data.kinemail,
          nextOfKinPhoneNumber: data.kinphone,
          nextOfKinRelationship: data.kinrelationship,
          nextOfKinAddress: data.kinaddress,
        };

        var updatekinres = await onUpdateKinDetails(
          selectedEmployee.id,
          kinPostData,
          config
        );

        if (updatekinres.success) {
          toast.success(updatekinres.message);
          setkindetails(updatekinres.data);
        }
      }

      if (!emgdetails.employeeID) {
        //emgdetails has not been added before and is an add instead of update
        let emgcontactPostData = {
          employeeID: selectedEmployee.id,
          emergencyContactName: data.emgname,
          emergencyContactPhone: data.emgphone,
          emergencyContactRelationship: data.emgrelationship,
        };

        var addemgres = await onAddEmployeeemgContact(
          emgcontactPostData,
          config
        );

        if (addemgres.success) {
          toast.success(addemgres.message);
          setemgdetails(addemgres.data);
        }
      } else {
        // update emgdetails
        let emgcontactPostData = {
          emergencyContactName: data.emgname,
          emergencyContactPhone: data.emgphone,
          emergencyContactRelationship: data.emgrelationship,
        };

        var addemgres = await onUpdateContactDetails(
          selectedEmployee.id,
          emgcontactPostData,
          config
        );

        if (addemgres.success) {
          toast.success(addemgres.message);
          setemgdetails(addemgres.data);
        }
      }
    } catch (e: any) {
      console.log(e);
      toast.error(e);
      setLoading(false);
    }
    setLoading(false);
  };

  const getKinDetails = async () => {
    try {
      var kinres = await onGetemployeeKin(selectedEmployee?.id, config);
      if (kinres.data) {
        setkindetails(kinres.data);
      }
    } catch (e: any) {
      //  toast.error(e);
      console.log(e);
    }
  };

  const getEmgContact = async () => {
    try {
      var emgres = await onGetemployeeEmgContact(selectedEmployee?.id, config);
      if (emgres.data) {
        console.log(emgres.data, "nbnbnb");
        setemgdetails(emgres.data);
      }
    } catch (e: any) {
      //  toast.error(e);
      console.log(e);
    }
  };
  const init = async () => {
    setLoading(true);
    await getKinDetails();
    await getEmgContact();
    setLoading(false);
  };

  useEffect(() => {
    init();
  }, []);


  useEffect(()=>{
setValue("firstname",selectedEmployee.firstName )
setValue("lastname",selectedEmployee.lastName )
setValue("lastname",selectedEmployee.lastName )
setValue("email",selectedEmployee.workEmail )
setValue("phone",selectedEmployee.workPhone )
setValue("city",selectedEmployee.city )
setValue("emgname",emgdetails.emergencyContactName)
setValue("address", selectedEmployee.workLocation ? selectedEmployee.workLocation : "" )
setValue("emgphone", emgdetails.emergencyContactPhone )
setValue("emgrelationship", emgdetails.emergencyContactRelationship )
setValue("kinfirstname", kindetails.nextOfKinFirstName )
setValue("kinlastname", kindetails.nextOfKinLastName )
setValue("kinemail", kindetails.nextOfKinEmail )
setValue("kinphone", kindetails.nextOfKinPhoneNumber )
setValue("kinaddress", kindetails.nextOfKinAddress )
setValue("kinrelationship", kindetails.nextOfKinRelationship )


  },[selectedEmployee, emgdetails])
  return (
    <div>
      <div className=" grid grid-cols-2 gap-4  	 ">
        <InputField
          name="firstname"
          title="Firstname"
          placeholder={"Firstname"}
           control={control}
          rules={{
            required: "First name is required",
            pattern: {
              value: textReg,
              message: "Invalid first name",
            },
          }}
        />
        <InputField
          name="lastname"
          title="Lastname"
          placeholder={"lastname"}
           control={control}
          rules={{
            required: "last name is required",
            pattern: {
              value: textReg,
              message: "Invalid last name",
            },
          }}
        />

        <InputField
          name="email"
          title="Email Address"
          placeholder={"Enter Email Address"}
           control={control}
          isDisabled={true}
          rules={{
            required: "Email Address is required",
            pattern: {
              value: emailReg,
              message: "Invalid Email Address",
            },
          }}
        />

        <InputField
          name="phone"
          title="Phone number"
          placeholder={"Enter phone number"}
          control={control}
           rules={{
            required: "Phone number is required",
            pattern: {
              value: numReg,
              message: "Invalid phone number",
            },
          }}
        />

        <Datepicker
          defaultvalue={  selectedEmployee.dateOfBirth? { code: new Date(selectedEmployee.dateOfBirth), name: new Date(selectedEmployee.dateOfBirth).toISOString() }:{ code: new Date(), name: new Date().toISOString() }}
          hook={dateofbirthPick}
          title="Date of birth"
        />
        {/* 
          <ListPicker
            fullwidth
            hook={maritalPickhook}
            title="Maritlal status"
            list={[
              { code: "single", name: "Single" },
              { code: "married", name: "Married" },
              { code: "divorced", name: "Divorced" },
            ]}
          /> */}
        <ListPicker
          hook={genderPickhook}
          title="Gender"
          defaultvalue={{name:selectedEmployee.gender,code:selectedEmployee.gender}}
          list={[
            { code: "male", name: "Male" },
            { code: "female", name: "Female" },
          ]}
        />
        <ListPicker
          hook={nationalityPickhook}
          defaultvalue={{name:selectedEmployee.country,code:selectedEmployee.country}}

          title="Nationality"
          list={countries}
        />
      </div>

      <p className="text-sm font-semibold ">Address</p>
      <InputField
        name="address"
        title="Address"
        placeholder={"Enter addresss"}
        
        control={control}
        rules={{
          required: "Address is required",
          pattern: {
            value: addressRegex,
            message: "Invalid address",
          },
        }}
      />
      <InputField
        name="address_additional"
        title="Additional information (Optional)"
        placeholder={"Enter additional info"}
        defaultvalue=""
        control={control}
      />

      <div className="grid grid-cols-2 gap-4">
        <InputField
          name="city"
          title="City"
           placeholder={"City"}
          control={control}
          rules={{
            required: "City is required",
            pattern: {
              value: addressRegex,
              message: "Invalid city",
            },
          }}
        />
        <ListPicker
          hook={countrypicked}
          title="Country"
          list={countries}
          defaultvalue={
            selectedEmployee?.country
              ? countries.filter((i) => i.name == selectedEmployee?.country)[0]
              : countries.filter((i) => i.name == SelectedOrg?.country)[0]
          }
        />
      </div>

      {/* Emergency contact details */}

      <p className="text-sm font-semibold">Emergency Contact</p>
      <div className="grid grid-cols-2 gap-2">
        <InputField
          name="emgname"
          title="Name"
           placeholder={"name"}
          control={control}
          rules={{
            required: "name is required",
            pattern: {
              value: textReg,
              message: "Invalid name",
            },
          }}
        />
        <InputField
          name="emgphone"
          title="Phone number"
          placeholder={"Enter phone number"}
          control={control}
           rules={{
            required: "Phone number is required",
            pattern: {
              value: numReg,
              message: "Invalid phone number",
            },
          }}
        />
      </div>
      <InputField
        name="emgrelationship"
        title="Relationship"
        placeholder={"Relationship"}
         control={control}
        rules={{
          required: "Relationship is required",
          pattern: {
            value: textReg,
            message: "Invalid relationship",
          },
        }}
      />
      {/* Next of kin details */}

      <p className="text-sm font-semibold ">Next of kin</p>
      <div className="grid grid-cols-2 gap-4">
        <InputField
          name="kinfirstname"
          title="Firstname"
          placeholder={"Firstname"}
           control={control}
          rules={{
            required: "First name is required",
            pattern: {
              value: textReg,
              message: "Invalid first name",
            },
          }}
        />
        <InputField
          name="kinlastname"
          title="Lastname"
          placeholder={"lastname"}
          control={control}
           rules={{
            required: "last name is required",
            pattern: {
              value: textReg,
              message: "Invalid last name",
            },
          }}
        />

        <InputField
          name="kinemail"
          title="Email Address"
          placeholder={"Enter Email Address"}
          control={control}
           rules={{
            required: "Email Address is required",
            pattern: {
              value: emailReg,
              message: "Invalid Email Address",
            },
          }}
        />

        <InputField
          name="kinphone"
          title="Phone number"
          placeholder={"Enter phone number"}
          control={control}
           rules={{
            required: "Phone number is required",
            pattern: {
              value: numReg,
              message: "Invalid phone number",
            },
          }}
        />

        <InputField
          name="kinaddress"
          title="Address"
          placeholder={"Enter addresss"}
          control={control}
           rules={{
            required: "Address is required",
            pattern: {
              value: addressRegex,
              message: "Invalid address",
            },
          }}
        />

        <InputField
          name="kinrelationship"
          title="Relationship"
          placeholder={"Relationship"}
           control={control}
          rules={{
            required: "Relationship is required",
            pattern: {
              value: textReg,
              message: "Invalid relationship",
            },
          }}
        />
      </div>

      <div className="w-full  flex justify-end items-center">
        <Button
          width={200}
          disabled={false}
          text={
            <>
              <FaSave size={15} className=" mx-1 inline" /> Save Changes{" "}
            </>
          }
          onBtnClick={handleSubmit(onSubmit)}
        />
      </div>
    </div>
  );
};
